// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ejdX","paper":"styles_paper__2eiPr","table":"styles_table__eUON8","tableWrapper":"styles_tableWrapper__2vtXd"};